import { Button, ButtonProps } from 'primereact/button';
import { useTranslation } from 'react-i18next';

import useDialogContext from '../../../../../../../../hooks/dialog/useDialogContext';
import { IRequest } from '../../../../../../../../shared/interfaces/IRequest';

interface AnswerButtonProps extends ButtonProps {
  productTask: IRequest;
}

const AnswerButton = (props: AnswerButtonProps): JSX.Element => {
  const { productTask, ...restProps } = props;
  const { openDialog } = useDialogContext();
  const { t } = useTranslation();

  const onClick = () => {
    openDialog('answer-product-task-dialog', {
      productTask,
    });
  };

  return (
    <Button
      label={t('tasksPage.tabs.productTasksTab.buttons.answer')}
      onClick={onClick}
      {...restProps}
    />
  );
};

export default AnswerButton;
